export {
    ActivityCorrectionMarker,
    CORRECTION_MARKER_SIZE,
    type ActivityCorrectionMarkerProps,
} from "./ActivityCorrectionMarker"
